import styled from 'styled-components';

import { Title } from '@yoweb/ui/components/typography';
import { getSpace, getFontWeight } from '@yoweb/ui/styles/utils/theme';
import { useTranslation } from '@yoweb/next-i18next';

type LegalHeroProps = {
  title: string;
  date: string;
  company?: string;
};

export const LegalHero = ({ title, date, company }: LegalHeroProps) => {
  const { t } = useTranslation('legal');
  return (
    <HeroGrid>
      <div>
        {company ? <Title size={{ _: 'lg', md: 'xl' }}>{company}</Title> : null}
        <Title as="h1" size={{ _: 'lg', md: 'xl' }}>
          {title}
        </Title>
      </div>
      {date && (
        <Title size={{ _: 'xs', md: 'sm' }}>
          {t('effective-date')} <Regular>{date}</Regular>
        </Title>
      )}
    </HeroGrid>
  );
};

const HeroGrid = styled.div`
  display: grid;
  grid-gap: ${getSpace('normal2')};
`;
const Regular = styled.span`
  font-weight: ${getFontWeight('regular')};
`;
